// extracted by mini-css-extract-plugin
export default {"container":"Gradient_container__XPaGY","editButton":"Gradient_editButton__UH35I","popover":"Gradient_popover__s3cMK"};